const store = {
    namespaced: true,
    state: {
        pagination: {
            current_page: null,
            total_pages: null,
        },
        search_params: {
            name: null,
            barcode: null,
            page: null,
        },
        show_filter: false,
    },
    actions: {
    },
    mutations: {
        set_current_page(state, payload) {
            state.pagination.current_page = payload
        },
        set_total_pages(state, payload) {
            state.pagination.total_pages = payload
        },
        init_search_params(state) {
            state.search_params = {
                name: null,
                barcode: null,
                page: null,
            }
        },
        toggle_filter(state) {
            state.show_filter = !state.show_filter
        },
    }
}

export default store
